import React, { Component, Fragment } from 'react';
import { FormHelperText, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

export default class StringNumber extends Component {

    constructor(props) {
        super(props);
        this.state = {
            errorText: (props.errorText === undefined || props.errorText === null) ? '' : props.errorText,
            error: props.error,
            defaultValue: this.props.defaultValue,
            focus: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }

    UNSAFE_componentWillReceiveProps(next_props) {
        if (next_props.initial !== undefined && next_props.initial) {
            this.setState({ error: next_props.error, errorText: '', defaultValue: next_props.defaultValue });
        } else {
            this.setState({ error: next_props.error, errorText: (next_props.errorText === undefined || next_props.errorText === null) ? '' : next_props.errorText });
        }

    }

    handleChange = (event) => {
        let value = event.target.value

        if (value && this.props.type === 'number') {
            value = parseInt(value)
            if (this.props.InputProps?.inputProps?.min !== undefined && value < this.props.InputProps.inputProps.min) {
                value = this.props.InputProps.inputProps.min
            }
            if (this.props.InputProps?.inputProps?.max !== undefined && value > this.props.InputProps.inputProps.max) {
                value = this.props.InputProps.inputProps.max
            }
            value = value.toString()
        }

        this.setState({ defaultValue: value });
        this.props.onChange && this.props.onChange(value);
        if (this.props.handleError !== undefined) {

            if (this.props.handleError) {
                if (value === '') {
                    this.setState({ errorText: this.props.placeholder, error: true });
                } else {
                    this.setState({ errorText: '', error: false });
                }
            }
        }
    }

    resetValue = () => {
        this.setState({
            defaultValue: '',
            errorText: '',
            error: false
        })
    }

    onBlur() { setTimeout(() => { if (this.state.focus) { this.setState({ focus: false }); } }, 0) }

    onFocus() { if (!this.state.focus) { this.setState({ focus: true }); } }

    render() {

        const OnFocusHideFixedElements = withStyles({
            "@global": {
                "body .headroom": { '@media (max-width: 960px)': { transform: "translate3d(0px, -100%, 0px)!important" } }
            }
        })(() => null);

        return (
            <Fragment>
                {this.state.focus && <OnFocusHideFixedElements />}
                <TextField
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    className={`TextField-StringNumber inputDisabledGrey ${this.props.classNameCustom}`}
                    variant="outlined"
                    size={this.props.size}
                    error={this.state.error}
                    id={this.props.id}
                    label={this.props.label}
                    placeholder={this.props.placeholder}
                    helperText={this.state.errorText}
                    onChange={this.handleChange}
                    value={this.state.defaultValue}
                    name={this.props.name}
                    disabled={this.props.disabled}
                    required={this.props.required}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    autoComplete='off'
                    multiline={this.props.multiline ? true : false}
                    minRows={this.props.rows}
                    type={this.props.type || 'string'}
                    InputProps={{ ...this.props.InputProps }}
                    style={{ ...this.props.style }}
                    inputProps={{
                        maxLength: this.props.maxLength || null
                    }}
                />
                {this.props.helperText && (
                    <FormHelperText error={this.state.error}>{this.props.helperText}</FormHelperText>
                )}
            </Fragment>
        );
    };
};

